export default __webpack_public_path__ + "static/media/streaks 50.1538584c.svg";